import { LoaderFunction, redirect } from "react-router-dom";

import AuthRequests from "@/api/auth/auth.requests.ts";
import { authAxios } from "@/api/axios.ts";
import { queryClient } from "@/api/query-client.tsx";
import UserRequests from "@/api/user/user.requests.ts";
import { ROUTES } from "@/config/routes.ts";
import { USER_KEYS } from "@/hooks/api/user.hooks.ts";

export const updateProfileLoader: LoaderFunction = async ({ params }) => {
  const { id } = params as { id: string };
  if (!/^\d+$/.test(id)) {
    return redirect(ROUTES.GATE.PROFILES);
  }

  const refresh = localStorage.getItem("splay:refresh");

  if (!refresh) {
    return redirect(ROUTES.GATE.PROFILES);
  } else {
    try {
      const { access } = await AuthRequests.postRefreshAccessToken(refresh);
      localStorage.setItem("splay:access", access);
      authAxios.defaults.headers.common["Authorization"] = `Bearer ${access}`;
    } catch (error) {
      return redirect(ROUTES.GATE.PROFILES);
    }
  }

  return queryClient
    .fetchQuery({
      queryKey: USER_KEYS.profileDetail(Number(id)),
      queryFn: () => UserRequests.getProfileDetail(Number(id)),
      staleTime: 1000 * 60,
      retry: 0,
    })
    .catch(() => redirect(ROUTES.GATE.PROFILES));
};
